/**
 * Product Recommend Setup (V2)
 * Entry point / integration (DI)
 */

import { ProductRecommendApi } from "./product-recommend-api";
import { ProductRecommendHandler } from "./product-recommend-handler";
import { ProductRecommendListener } from "./product-recommend-listener";
import { ProductRecommendRender } from "./product-recommend-render";

export class ProductRecommendSetup {
    public static init(): void {
        if (document.documentElement.dataset.productRecommendInit === "1") return;
        document.documentElement.dataset.productRecommendInit = "1";

        const render = new ProductRecommendRender();
        const handler = new ProductRecommendHandler({ api: ProductRecommendApi, render });
        const listener = new ProductRecommendListener({ handler });
        listener.register();
    }
}

export function initProductRecommendSystem(): void {
    ProductRecommendSetup.init();
}
